(function() {
  window.adConfigs = window.adConfigs || {};

  // TODO: Replace these with craft-specific PDP hero images once shot.
  // Craft images should be process-led: hands tempering, mid-enrobe shots,
  // bars being cut from slab, cooler lighting, wider compositions.
  // Current null values will fall back to ad-handler.js default behaviour.
  const craftImages = {
    'aaaa': null,
    'enrobingtriocraft': 'https://cdn.shopify.com/s/files/1/0869/7387/4512/files/Screenshot_2026-04-30_at_10.27.01.png?v=1777541235',
  };

  const craftFlavours = {
    'enrobingtriocraft': 'Caramel',
    'caramel2':     'Caramel',
    'caramel3':     'Caramel',
  };

  const subtitle = 'Small-batch chocolate bars<br>Made the slow way';
  const socialProof = '★★★★★ The real deal';

  Object.entries(craftFlavours).forEach(([key, displayName]) => {
    const pdpImage = craftImages[key];

    // No cart image change for build a box
    window.adConfigs[`craft-bab-${key}`] = {
      subtitle,
      heroImage: pdpImage,
      cartImage: null,
      socialProof,
      flavour: displayName,
    };
  });
})();